var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialOfferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15625 2.65314V7.32501C1.15625 7.85626 1.36563 8.36564 1.74063 8.74064L7.24062 14.2406C8.02187 15.0219 9.2875 15.0219 10.0688 14.2406L14.2406 10.0688C15.0219 9.28751 15.0219 8.02189 14.2406 7.24064L8.74062 1.74064C8.36562 1.36564 7.85625 1.15626 7.325 1.15626H2.65625C1.82812 1.15314 1.15625 1.82501 1.15625 2.65314ZM4.65625 5.65314C4.10313 5.65314 3.65625 5.20626 3.65625 4.65314C3.65625 4.10001 4.10313 3.65314 4.65625 3.65314C5.20937 3.65314 5.65625 4.10001 5.65625 4.65314C5.65625 5.20626 5.20937 5.65314 4.65625 5.65314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialOfferIcon);
export default __webpack_public_path__ + "static/media/specialOfferIcon.75c332f4f0960f7a805470bbe20ddc86.svg";
export { ForwardRef as ReactComponent };